<form [formGroup]="paginationForm">
  <div class="pagination">
    <div class="page-text-items-page" *ngIf="itemsPageOptions.length > 1">Items por Página</div>
    <sc-select class="page-select" placeholder="" formControlName="pageItem" [items]="itemsPageOptions" [enableSearch]="false"
      (optionSelected)="changeItemForPage($event)" *ngIf="itemsPageOptions.length > 1"></sc-select>
    <div class="page-text ml-auto">Página {{data.actualPage}} de {{data.totalPages}}</div>
    <a class="page-link page-link_left" (click)="back()">
      <sc-icon icon="arrow-left" size="1"></sc-icon>
    </a>
    <a class="page-link page-link_right" (click)="next()">
      <sc-icon icon="arrow-right" size="1"></sc-icon>
    </a>
  </div>
</form>
